import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import RequestServies from "../../../services/RequestServices";

function ApproveOrRejectRequisitionModal({ show, item, handleClose, onSuccess }) {
  const [errormsg, setErrormsg] = useState();
  const [previewImage, setPreviewImage] = useState("img/placeholder-img.png");

  const [formValues, setFormValues] = useState({
    inventory: item?._id,
    partNo: 0,
    mivNo: "",
    totalRecive: "",
    description: "",
    unit: "",
    remark: "",
    qtyAuth: 0,
    currentStock: 0,
    demand: 0,
    usedQty: 0,
    indigoStock: 0,
    approveQty: 0,
    user: "",
    store: "",
    image: null,
  });

  useEffect(() => {
    if (item) {
      setFormValues({
        ...formValues,
        partNo: item?.inventory?.masterItem?.partNo || 0,
        totalRecive: item?.inventory?.totalRecive || 0,
        qtyAuth: item?.inventory?.qtyAuth || 0,
        description: item?.inventory?.masterItem?.description || "",
        unit: item?.inventory?.masterItem?.unit?.name || "",
        currentStock: item?.inventory?.currentStock || 0,
        demand: item?.inventory?.qtyAuth - item?.inventory?.currentStock || 0,
        user: item?.user?.name || " ",
        store: item?.requisitionNo?.store?.name || "",
        usedQty: item?.usedQty || 0,
        requisitionNo: item?.requisitionNo?.requisitionNo || 0,
        approveQty: item?.usedQty || 0,
        adminRemark: "",
      });
      if (item?.miv?.image) {
        setPreviewImage(
          "https://indigoinfra.in/img/miv/" + item?.miv?.image
        );
      }
    }
  }, [item]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (name === "approveQty") {
      if (value > formValues.usedQty) {
        setErrormsg("Quantity approved should be less than or equal to used");
      } else {
        setErrormsg("");
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event, status) => {
    event.preventDefault();
    try {
      // Optional: you can still build formData here if needed for future use
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== "image" || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      // Ensure approveQty is a number before sending
      const payload = {
        approveQty: Number(formValues.approveQty),
        status: status,
        adminRemark: formValues.remark,
      };

      // Optional validation
      if (!payload.approveQty || payload.approveQty > formValues.usedQty) {
        setErrormsg("Approved quantity is invalid");
        return;
      }

      await RequestServies.updateUsedItem(item._id, payload);

      onSuccess();
      alert("Requisition form submitted successfully.");
      handleClose();
    } catch (error) {
      console.error("API Error:", error?.response?.data || error.message || error);
      alert(error?.response?.data?.message || "Something went wrong. Please check your input.");
    }
  };


  return (
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Used Item Form</Modal.Title>
          <Button variant="close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Part No</label>
                <input
                  type="number"
                  name="partNo"
                  className="form-control form-control-sm"
                  value={formValues.partNo}
                  readOnly
                />
              </Col>

            </Row>
            <Row>
              <Col md="12">
                <label>Description</label>
                <textarea
                  rows="3"
                  name="description"
                  className="form-control form-control-sm"
                  value={formValues.description}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Unit</label>
                <input
                  type="text"
                  name="unit"
                  className="form-control form-control-sm"
                  value={formValues.unit}
                  readOnly
                />
              </Col>

            </Row>
            <Row>

              <Col md="6">
                <label>Current Stock</label>
                <input
                  type="number"
                  name="currentStock"
                  className="form-control form-control-sm"
                  value={formValues.currentStock}
                  readOnly
                />
              </Col>


              <Col md="6">
                <label>Qty Used</label>
                <input
                  type="number"
                  name="usedQty"
                  className="form-control form-control-sm"
                  value={formValues.usedQty}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Qty Approve</label>
                <input
                  type="number"
                  name="approveQty"
                  className="form-control form-control-sm"
                  value={formValues.approveQty}
                  onChange={handleInputChange}
                />
                {errormsg && <div style={{ color: "red" }}>{errormsg}</div>}
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Indigo Stock</label>
                <input
                  type="number"
                  name="indigoStock"
                  className="form-control form-control-sm"
                  value={formValues.indigoStock}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6">
                <label>Store Keeper</label>
                <input
                  type="text"
                  name="user"
                  className="form-control form-control-sm"
                  value={formValues.user}
                  readOnly
                />
              </Col>
            </Row>
            <Row>

              <Col md="6">
                <div className="input-field">
                  <div className="file-preview text-center">
                    <img
                      id="uploadFile"
                      src={previewImage}
                      alt="Preview"
                      className="img-fluid"
                    />
                  </div>

                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={(event) => handleSubmit(event, 'approved')}>
            Approve
          </Button>
          <Button variant="danger" onClick={(event) => handleSubmit(event, 'rejected')}>
            Reject
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ApproveOrRejectRequisitionModal;
